import React from "react";
import {ellipsis, subduedTextColour} from "../../style/styleConsts";
import IdeaType from "../idea/IdeaType";
import {RedactCommentary} from "../redact/RedactCommentary";

const innerActivityCellStyles = {
   ...ellipsis,
   margin: "0 5px",
   flexShrink: 0
};

const tickerStyle = {
    fontWeight: "bold",
    marginRight: "0.4em"
};

function StocksDisplay (props) {
    return  <div style={ellipsis}>
                <span style={tickerStyle}>
                    {props.recommendation.bloomberg}
                </span>
                <span>
                    {props.recommendation.companyName}
                </span>
            </div>;
}

const AuthorAction = ({ideaType, recommendation, comment}) => (
  <div style={{display: "flex", flexGrow: 1, flexShrink: 1}}>
    <div className="t-idea-type" style={{ ...innerActivityCellStyles,  flexBasis: "4em"}}><IdeaType type={ideaType} /></div>
    <div className="t-stocks" style={{ ...innerActivityCellStyles, flexBasis:"9em"}}><StocksDisplay recommendation={recommendation}/></div>
      <div className="t-comment" style={{ ...innerActivityCellStyles,  flexShrink: 1, flexGrow: 1, color: subduedTextColour}}><RedactCommentary>{comment}</RedactCommentary></div>
  </div>
);

export default AuthorAction;
